module.exports = __webpack_public_path__ + "static/media/ImgConsultantsTable1.6f996a2b.jpg";